/**
 * @deprecated
 */
export const createForceRefreshHandler = route => event => {
  event.preventDefault();

  window.location.href = route;
};
